
import { mapMutations } from 'vuex'
import AppModal from './AppModal.vue'
import ClassBox from './ClassBox.vue'
import AppSpin from '@/components/AppSpin.vue'

export default {
  name: 'ClassModal',
  components: {
    AppModal,
    ClassBox,
    AppSpin,
  },
  data() {
    return {
      classes: [],
      search: '',
    }
  },
  computed: {
    newClasses() {
      return this.$store.state.class.newClasses
    },
    oldClasses() {
      return this.$store.state.class.oldClasses
    },
  },
  watch: {
    search() {
      this.$store.commit('class/filterNewClasses', this.search)
    },
  },
  async mounted() {
    await this.$store.dispatch('class/getClasses')
  },
  methods: {
    ...mapMutations({ toggleClassModal: 'modal/toggleClassModal' }),
    changeClass(classe) {
      localStorage.classId = classe.id
      localStorage.className = classe.name
      localStorage.required_documents = classe.required_documents
      if (classe.services.length) {
        localStorage.serviceType = classe.services[0].type
        localStorage.serviceName = classe.services[0].name
        localStorage.serviceToken = classe.services[0].token
        localStorage.serviceAssistant =
          classe.services[0].config.assistant_token
        localStorage.serviceBaseUrl = classe.services[0].base_url
        localStorage.serviceQuestions = JSON.stringify(
          classe.services[0].config.questions_default
        )
      } else {
        localStorage.removeItem('serviceType')
        localStorage.removeItem('serviceName')
        localStorage.removeItem('serviceToken')
        localStorage.removeItem('serviceAssistant')
        localStorage.removeItem('serviceBaseUrl')
        localStorage.removeItem('serviceQuestions')
        if (this.$route.name === 'IA') {
          this.$router.push({ path: `/` })
        }
      }
      if (classe.required_documents.length) {
        localStorage.required_documents = JSON.stringify(
          classe.required_documents
        )
      } else {
        localStorage.removeItem('required_documents')
      }
      this.$store.commit('modal/toggleClassModal')
      window.location.href = '/'
    },
  },
}
